/*
 * @Author: Hugo
 * @Date: 2020-10-13 13:33:22
 * @LastEditTime: 2020-10-15 11:23:16
 * @LastEditors: Please set LastEditors
 * @Description: 节点类
 * @FilePath: /Workbench_Front_Support/src/workbench_front/common/models/Node/index.js
 */
export default class Node {
    constructor(params) {
        this.data = params;
        this.parent = null;
        this.children = [];
    }
}
